import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SearchRight",
  "use": "SearchRight-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"SearchRight\"><defs><path d=\"M12.562 11.25c.115.05.223.12.317.214l2.828 2.829a1 1 0 0 1-1.414 1.414l-2.829-2.828a.997.997 0 0 1-.213-.317 7 7 0 1 1 1.311-1.311ZM7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10Z\" id=\"SearchRight_a\" /></defs><use xlink:href=\"#SearchRight_a\" transform=\"translate(4 4)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol